import HomeDashP1 from './views/ob/HomeDashP1'
import PersonalDetailsP1 from './views/ob/PersonalDetailsP1'
import PersonalDetailsMoreP1 from './views/ob/PersonalDetailsMoreP1'
import PassportP1 from './views/ob/PassportP1'
import PoliciesFormsP1 from './views/ob/PoliciesFormsP1'
import FeedbackP1 from './views/ob/FeedbackP1'
import FeedbackMoreP1 from './views/ob/FeedbackMoreP1'
import FirstDayCheckP1 from './views/ob/FirstDayCheckP1'
import ActionsP1 from './views/ob/ActionsP1'
import HandbookP1 from './views/ob/HandbookP1'

export default {
  firstName: "Oliver",
  lastName: "Benson",
  personaViews: [
    {
      image: "HomeDashP1",
      images: ["OB-Homepage-1", "OB-Homepage-2", "OB-Homepage-3"],
      title: "homeDashboard.persona1.title",
      body: "homeDashboard.persona1.body",
      hotspots: HomeDashP1,
      index: 0,
    },
    {
      image: "PersonalDetailsP1",
      images: ["OB-Personal-Details"],
      title: "personalDetails.persona1.title",
      body: "personalDetails.persona1.body",
      hotspots: PersonalDetailsP1,
      index: 1,
    },
    {
      image: "PersonalDetailsMoreP1",
      images: ["OB-Personal-Details-More", "OB-Personal-Details-More-Edit"],
      title: "personalDetailsMore.persona1.title",
      body: "personalDetailsMore.persona1.body",
      hotspots: PersonalDetailsMoreP1,
      index: 2,
    },
    {
      image: "PassportP1",
      images: ["OB-Passport"],
      title: "passport.persona1.title",
      body: "passport.persona1.body",
      hotspots: PassportP1,
      index: 3,
    },
    {
      image: "PoliciesFormsP1",
      images: ["OB-Policies-Forms"],
      title: "policies.persona1.title",
      body: "policies.persona1.body",
      hotspots: PoliciesFormsP1,
      index: 4,
    },
    {
      image: "FeedbackP1",
      images: ["OB-Feedback"],
      title: "feedback.persona1.title",
      body: "feedback.persona1.body",
      hotspots: FeedbackP1,
      index: 5,
    },
    {
      image: "FeedbackMoreP1",
      images: ["OB-Feedback-More"],
      title: "feedbackMore.persona1.title",
      body: "feedbackMore.persona1.body",
      hotspots: FeedbackMoreP1,
      index: 6,
    },
    {
      image: "FirstDayCheckP1",
      images: ["OB-First-Day"],
      title: "firstDayChecklist.persona1.title",
      body: "firstDayChecklist.persona1.body",
      hotspots: FirstDayCheckP1,
      index: 7,
    },
    {
      image: "ActionsP1",
      images: ["OB-Actions-Overview"],
      title: "actions.persona1.title",
      body: "actions.persona1.body",
      hotspots: ActionsP1,
      index: 8,
    },
    {
      image: "HandbookP1",
      images: ["OB-Handbook"],
      title: "handbook.persona1.title",
      body: "handbook.persona1.body",
      hotspots: HandbookP1,
      index: 9,
    },
  ],
};
